import script from "./OkrElementsTableNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrElementsTableNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./OkrElementsTableNumberInput.vue?vue&type=style&index=0&id=26183d0d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26183d0d"]])

export default __exports__